export default function Analytics() {
  return (
    <div>
      <h2 style={{
        color: 'var(--sand-900)',
        fontFamily: "'Playfair Display', serif",
        fontSize: '2rem',
        marginBottom: '1rem'
      }}>
        Analytics & Reports
      </h2>
      <div className="card" style={{ padding: '2rem' }}>
        <p style={{ color: 'var(--sand-700)' }}>
          Analytics and reporting features coming soon...
        </p>
      </div>
    </div>
  );
}
